export default __webpack_public_path__ + "static/media/smsLogs.08854c80.png";